export const PLANNING_BREACH_BASE_PATH = '/planning-breach';
export const RoutesList = {
  PLANNING_BREACH_HOME: PLANNING_BREACH_BASE_PATH,
  ISSUE_TYPE: PLANNING_BREACH_BASE_PATH + '/issue-type',
  PHOTO_UPLOAD: PLANNING_BREACH_BASE_PATH + '/photo-upload',
  ISSUE_LOCATION: PLANNING_BREACH_BASE_PATH + '/issue-location',
  ADVERTISEMENT_DATE:
    PLANNING_BREACH_BASE_PATH + '/date-of-unauthorised-advertisement-issue',
  CHANGE_DATE: PLANNING_BREACH_BASE_PATH + '/date-of-unauthorised-change-issue',
  INSTALLATION_DATE:
    PLANNING_BREACH_BASE_PATH + '/date-of-unauthorised-installation-issue',
  WORKS_DATE: PLANNING_BREACH_BASE_PATH + '/date-of-unauthorised-works-issue',
  BREACH_DATE: PLANNING_BREACH_BASE_PATH + '/date-of-breach-issue',
  PLANNING_PERMISSON: PLANNING_BREACH_BASE_PATH + '/breach-of-the-condition',
  PROPERTY_USAGE: PLANNING_BREACH_BASE_PATH + '/property-usage',
  SHORT_TERM_LETS_DATE:
    PLANNING_BREACH_BASE_PATH + '/date-of-short-term-lets-issue',
  TELL_US_MORE_AD:
    PLANNING_BREACH_BASE_PATH + '/tell-us-more-unauthorised-advertisement',
  TELL_US_MORE_CHANGE:
    PLANNING_BREACH_BASE_PATH + '/tell-us-more-change-of-use',
  TELL_US_MORE_INSTALLATION:
    PLANNING_BREACH_BASE_PATH + '/tell-us-more-installation',
  TELL_US_MORE_WORKS: PLANNING_BREACH_BASE_PATH + '/tell-us-more-works',
  TELL_US_MORE_BREACH: PLANNING_BREACH_BASE_PATH + '/tell-us-more-breach',
  IS_AD_LIT_UP: PLANNING_BREACH_BASE_PATH + '/is-the-advertisement-lit-up',
  OWNER_LIVE_AT_PROP:
    PLANNING_BREACH_BASE_PATH + '/does-the-owner-live-at-the-property',
  AD_RESPONSIBILITY:
    PLANNING_BREACH_BASE_PATH + '/who-is-responsible-for-the-advertisement',
  CHANGE_RESPONSIBILITY:
    PLANNING_BREACH_BASE_PATH + '/who-is-responsible-for-the-change-of-use',
  INSTALLATION_RESPONSIBILITY:
    PLANNING_BREACH_BASE_PATH + '/who-is-responsible-for-the-installations',
  WORKS_RESPONSIBILITY:
    PLANNING_BREACH_BASE_PATH + '/who-is-responsible-for-the-works',
  SHORT_TERM_LETS_RESPONSIBILITY:
    PLANNING_BREACH_BASE_PATH + '/who-is-responsible-for-the-property',
  AD_PROBLEM: PLANNING_BREACH_BASE_PATH + '/advertisement-causing-a-problem',
  CHANGE_PROBLEM:
    PLANNING_BREACH_BASE_PATH + '/change-of-use-causing-a-problem',
  INSTALLATION_PROBLEM:
    PLANNING_BREACH_BASE_PATH + '/installtion-causing-a-problem',
  WORKS_PROBLEM: PLANNING_BREACH_BASE_PATH + '/works-causing-a-problem',
  BREACH_PROBLEM: PLANNING_BREACH_BASE_PATH + '/breach-causing-a-problem',
  SHORT_TERM_LETS_PROBLEM:
    PLANNING_BREACH_BASE_PATH + '/short-term-lets-causing-a-problem',
  SHORT_TERM_LETS_AD: PLANNING_BREACH_BASE_PATH + '/short-term-lets-details',
  WORKS_COMPLETED_DATE: PLANNING_BREACH_BASE_PATH + '/works-date-of-completion',
  ANY_MORE_INFO: PLANNING_BREACH_BASE_PATH + '/more-information',
  CONTACT_USER_OPTION: PLANNING_BREACH_BASE_PATH + '/can-we-contact-you',
  EMAIL_CONFIRMATION_REPORT:
    PLANNING_BREACH_BASE_PATH + '/email-confirmation-report',
  YOUR_DETAILS: PLANNING_BREACH_BASE_PATH + '/your-details',
  CONFIRMATION: PLANNING_BREACH_BASE_PATH + '/confirmation',
  CALLBACKS: PLANNING_BREACH_BASE_PATH + '/callbacks/*',
  NOT_FOUND: '*',
  INTERNAL_SERVER_ERROR: '/500',
};

export const steps = [
  {
    label: 'Issue type',
    urlPaths: [RoutesList.ISSUE_TYPE],
  },
  {
    label: 'Evidence',
    urlPaths: [RoutesList.PHOTO_UPLOAD],
  },
  {
    label: 'Location',
    urlPaths: [RoutesList.ISSUE_LOCATION],
  },
  {
    label: 'Issue details',
    urlPaths: [
      RoutesList.ADVERTISEMENT_DATE,
      RoutesList.CHANGE_DATE,
      RoutesList.INSTALLATION_DATE,
      RoutesList.WORKS_DATE,
      RoutesList.BREACH_DATE,
      RoutesList.SHORT_TERM_LETS_DATE,
      RoutesList.PLANNING_PERMISSON,
      RoutesList.PROPERTY_USAGE,
      RoutesList.TELL_US_MORE_AD,
      RoutesList.TELL_US_MORE_CHANGE,
      RoutesList.TELL_US_MORE_INSTALLATION,
      RoutesList.TELL_US_MORE_WORKS,
      RoutesList.TELL_US_MORE_BREACH,
      RoutesList.IS_AD_LIT_UP,
      RoutesList.OWNER_LIVE_AT_PROP,
      RoutesList.AD_RESPONSIBILITY,
      RoutesList.CHANGE_RESPONSIBILITY,
      RoutesList.INSTALLATION_RESPONSIBILITY,
      RoutesList.WORKS_RESPONSIBILITY,
      RoutesList.SHORT_TERM_LETS_RESPONSIBILITY,
      RoutesList.AD_PROBLEM,
      RoutesList.CHANGE_PROBLEM,
      RoutesList.INSTALLATION_PROBLEM,
      RoutesList.WORKS_PROBLEM,
      RoutesList.BREACH_PROBLEM,
      RoutesList.SHORT_TERM_LETS_PROBLEM,
      RoutesList.SHORT_TERM_LETS_AD,
      RoutesList.WORKS_COMPLETED_DATE,
      RoutesList.ANY_MORE_INFO,
    ],
  },

  {
    label: 'Your details',
    urlPaths: [
      RoutesList.EMAIL_CONFIRMATION_REPORT,
      RoutesList.CONTACT_USER_OPTION,
      RoutesList.YOUR_DETAILS,
    ],
  },
];
